const labUtils = (() => {
  /**
   * Fallback default value
   */
  function defaultTo(valueArg, defaultValue) {
    const value = valueArg;
    return value == null || value !== valueArg ? defaultValue : value;
  }

  function generateRandomId() {
    return Math.random().toString(36).substring(2, 12);
  }

  function isDeviceMobile() {
    if (navigator.userAgentData) {
      // Modern browsers supporting navigator.userAgentData
      return navigator.userAgentData.mobile;
    }
    // Fallback for browsers not supporting navigator.userAgentData
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
  }

  /**
   * throttle function
   * @param {string} callback the function
   * @param {number} delay delay between interactions
   */
  function throttle(callback, delay) {
    let inProgress = false;

    return (...args) => {
      if (inProgress) return;

      inProgress = true;
      setTimeout(() => {
        callback(...args);
        inProgress = false;
      }, delay);
    };
  }

  /**
   * debounce function
   * @param {string} callback the function
   * @param {number} delay delay between interaction is done and callback is called
   */
  function debounce(callback, delay) {
    let timeout;

    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        callback(...args);
      }, delay);
    };
  }

  return {
    defaultTo,
    generateRandomId,
    isDeviceMobile,
    throttle,
    debounce,
  };
})();

export const {defaultTo, generateRandomId, isDeviceMobile, throttle, debounce} = labUtils;
